import { render } from "./CharSRView.vue?vue&type=template&id=6487972b"
import script from "./CharSRView.vue?vue&type=script&lang=js"
export * from "./CharSRView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__